import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { ModalService } from '../shared/modal/modal.service';
import { ClientService } from '../create-client/client.service';
import { GlobalService } from '../services/global.service';
import { PagerService } from '../services/pager.service';
import { LoadingService } from '../shared/loading/loading.service';

import { Client } from '../models/client';

import Utility from '../shared/utility';

@Component({
  selector: 'app-client',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  public clients: any[] = [];
  public error: string;
  public role: number;

  public screenWidth: number = window.innerWidth;

  private allItems: any[];
  pager: any = {};
  pagedItems: any[];

  private filteredClients: any;
  public modalSubscription;
  public hasClients: boolean = false;
  public cloningClientId: number = null;
  public isHVS: boolean = false;

  constructor(private modalService: ModalService, private clientService: ClientService, private globalService: GlobalService, private pagerService: PagerService, private loadingService: LoadingService, private router: Router) {
    localStorage.setItem('isCreateClient', "False");
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClients();
        modal.data = {};
      }
    });
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    this.isHVS = this.role === 1 && Number(localStorage.getItem('orgID')) === 1;
    this.getClients();

  }

  createNewClient(){
    //localStorage.setItem('isCreateClient', "True");
    localStorage.setItem('advisor', "");
    localStorage.setItem('isCreateClient', "True");
    localStorage.setItem('isEditClient', "False");
    
    this.router.navigate(['/clients/create']);
  }

  public loading: boolean = false;
  getClients() {
    this.loadingService.isLoading(true);
    this.loading = true;
    this.globalService.getClientsData()
      .subscribe(
        clients => {
          // console.log('clients 01', clients);
          var spouses;
          this.hasClients = clients.length > 0;
          this.allItems = clients.map((item) => {
            spouses = JSON.parse(item.cp.Spouses) || [];

            if (item.c) {
              item.c.OrganizationName = item.o ? item.o.Name : '';
              // item.c.HasRanMiniQuestionnaire = (item.cp.CoverageType || item.cp.ClientMetroArea || item.cp.SSDesiredAgeYears || item.cp.MonthlyBenefitAmount || item.cp.PIA || item.cp.CurrentIncome > 0) ? true : false;
              item.c.HasRanMiniQuestionnaire = (item.cp.CoverageType || item.cp.ClientMetroArea || item.cp.SSDesiredAgeYears || item.cp.MonthlyBenefitAmount || item.cp.PIA || item.cp.CurrentIncome >= 0) || (item.cp.PremiumType) ? true : false;
              //item.c.CoverageType = item.cp.CoverageType;
              //item.c.ClientMetroArea = item.cp.ClientMetroArea;
              spouses.map((spouse) => {
                if (spouse && spouse.maritalStatus == 'Married') {
                  item.c.spouseName = spouse.firstName + " " + spouse.lastName;
                }
              });

              if (item.a) {
                item.c.AdvisorName = item.a.FirstName + " " + item.a.LastName;
                item.c.AdvisorID = item.a.ID;
                item.c.AdvisorOrgID = item.a.OrganizationID;
              }

              return item.c;
            } else {
              return item
            }
          });
          this.filteredClients = this.allItems;

          this.filteredClients = this.allItems.sort(function (a, b) {
            return parseInt(b.ID) - parseInt(a.ID);
          });
          this.setPage(1);
          this.loadingService.isLoading(false);
          this.loading = false;
        },
        error => {
          this.error = <any>error
          this.loadingService.isLoading(false);
          this.loading = false;
        });
  }



  setPage(page: number) {
    if (this.filteredClients.length === 1) {
      this.pagedItems = this.filteredClients;
      this.pager = this.pagerService.getPager(this.filteredClients.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    // this.pager = this.pagerService.getPager(this.allItems.length, page);
    this.pager = this.pagerService.getPager(this.filteredClients.length, page);

    // get current page of items
    this.pagedItems = this.filteredClients.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  handleCreateClientModal(e) {
    // this.modalService.add('add-edit-client', { ID: 0 });
    localStorage.setItem('isCreateClient', "True");
    this.router.navigate(['/clients/create']);
  }

  handleEditClientModal(e, client) {
    console.log('client', client);
    localStorage.setItem('selectedClient', client.ID);
    localStorage.setItem('selectedAdvisor', client.AdvisorName);
    localStorage.setItem('selectedAdvisorID', client.AdvisorID);
    localStorage.setItem('selectedAdvisorOrgID', client.AdvisorOrgID);
    this.router.navigate(['/clients/edit']);
    if(!client.HasRanMiniQuestionnaire){
      this.router.navigate(['/reports/new']);
    } else {
      //else, send to Client Hub
      this.router.navigate(['/clients/edit']);
    }
  }

  // getClientData(clientID) {
  //   this.globalService.getClientData(clientID, 4)
  //   .subscribe(
  //       client => {
  //         console.log('client',client);
         
  //         if (this.globalService.featSocialSecurity && !this.globalService.featHealthCare && !this.globalService.featLongTermCare && !this.globalService.featCombinedHealthcareLTC && !this.globalService.featMeansTesting) {
  //           let isSocialSecurityEdit = (client.clientProfile.Children || client.clientProfile.Pension || client.clientProfile.InRetFirstYearIncome || client.clientProfile.MonthlyBenefitAmount || client.clientProfile.SSDesiredAgeYears || client.clientProfile.Spouses.length > 1) ? true : false;
  //           if (isSocialSecurityEdit) {
  //             this.router.navigate(['/clients/edit']);
  //           } else {
  //             this.router.navigate(['/reports/new']);
  //           }
  //         }
  //         if (this.globalService.featSocialSecurity && this.globalService.featHealthCare && this.globalService.featLongTermCare && this.globalService.featCombinedHealthcareLTC && this.globalService.featMeansTesting) {
  //           let isCurrentIncome = client.clientProfile.CurrentIncome;
  //           if (isSocialSecurityEdit) {
  //             this.router.navigate(['/clients/edit']);
  //           } else {
  //             this.router.navigate(['/reports/new']);
  //           }
  //         }
      
      
  //         this.loadingService.isLoading(false);
  //     },
  //     error => this.error = <any>error);
  // }



  handleCreateReport(e, client) {
    console.log('client', client);
    localStorage.setItem('selectedClient', client.ID);
    localStorage.setItem('selectedAdvisor', client.AdvisorName);
    localStorage.setItem('selectedAdvisorID', client.AdvisorID);
    localStorage.setItem('selectedAdvisorOrgID', client.AdvisorOrgID);
    /* localStorage.setItem('isHCQuestionnaireFilled', 'false');
    localStorage.setItem('isLTCQuestionnaireFilled', 'false');*/

    if(!client.HasRanMiniQuestionnaire) {
      if (this.globalService.featSocialSecurity && !this.globalService.featHealthCare && !this.globalService.featLongTermCare && !this.globalService.featMeansTesting && !this.globalService.featCombinedHealthcareLTC) {
        //only has SS turned on
        this.router.navigate(['/clients/edit/social-security']); 
      } else if (!this.globalService.featSocialSecurity && this.globalService.featHealthCare && !this.globalService.featLongTermCare && !this.globalService.featMeansTesting && !this.globalService.featCombinedHealthcareLTC) {
        //only has HC turned on
        this.router.navigate(['/clients/edit/healthcare']); 
      } else if (!this.globalService.featSocialSecurity && !this.globalService.featHealthCare && this.globalService.featLongTermCare && !this.globalService.featMeansTesting && !this.globalService.featCombinedHealthcareLTC) {
        //only has LTC turned on
        this.router.navigate(['/clients/edit/long-term-care']); 
      } else if (!this.globalService.featSocialSecurity && !this.globalService.featHealthCare && !this.globalService.featLongTermCare && this.globalService.featMeansTesting && !this.globalService.featCombinedHealthcareLTC) {
        //only has MMT turned on
        //this.router.navigate(['/clients/edit/long-term-care']); 

        //this.router.navigate(['/reports/new']);
        this.router.navigate(['/clients/edit/healthcare']);
      } else if (!this.globalService.featSocialSecurity && !this.globalService.featHealthCare && !this.globalService.featLongTermCare && !this.globalService.featMeansTesting && this.globalService.featCombinedHealthcareLTC) {
        //only has combined turned on
        this.router.navigate(['/clients/edit/combined']); 
      } else {
        //has more than one feature turned on for this org, so we dont know which questionnaire to start with since they havent filled one out, show them the options again
        this.router.navigate(['/reports/new']);
      }

    } else {
      //else, send to Client Hub
      this.router.navigate(['/clients/edit']);
    }
  }

  cloneClient(event, client) {
    event.stopPropagation();
    if (this.cloningClientId) { return; }
    this.cloningClientId = client.ID;

    this.globalService.getClientData(client.ID, 4)
      .subscribe(
        data => {
          const UserModel = {
            AdvisorID: Number(localStorage.getItem('userId')),
            OrganizationID: Number(localStorage.getItem('orgID')),
            ID: 0,
            Username: data.client.Email,
            Email: data.client.Email,
            FirstName: data.client.FirstName + ' (Copy)',
            LastName: data.client.LastName,
            Address: data.client.Address,
            City: data.client.City,
            State: data.client.State,
            Zip: data.client.Zip,
            Phone: data.client.Phone,
            DOB: data.client.DOB,
            GenderID: Number(data.client.GenderID),
            ProgramFeePercent: data.client.ProgramFeePercent
          };

          const cp = data.clientProfile;
          cp.ClientID = 0;

          const RiskTolerance = {
            ClientID: 0,
            FinancialObjID: null,
            LvlOfInvestExpID: null,
            LngthOfInvestID: null,
            ToleranceOfRiskID: null,
            NeedRedeemID: null,
            AccountType: null,
            HasSignedAdvisoryAgreement: false,
            HasSignedUpForManagedAccount: false
          };

          this.globalService.createClient(UserModel, cp, RiskTolerance)
            .subscribe(
              resp => {
                this.cloningClientId = null;
                if (resp.error === 0) {
                  this.getClients();
                }
              },
              error => {
                this.cloningClientId = null;
                this.error = error;
              }
            );
        },
        error => {
          this.cloningClientId = null;
          this.error = error;
        }
      );
  }

  assignCopy() {
    this.filteredClients = Object.assign([], this.allItems);
  }

  filterItem(value) {
    const searchTerms = value.toLowerCase().split(' ').filter(Boolean); // Split input into words and remove any empty strings

    this.filteredClients = Object.assign([], this.allItems).filter(advisor => {
      // Prepare full name combinations to check against the input
      const fullName = [
        advisor.FirstName,
        advisor.LastName,
        advisor.spouseName,
        advisor.AdvisorName,
        advisor.OrganizationName
      ].filter(Boolean).join(" ").toLowerCase(); // Combine all relevant names into a single string and lower case it

      // Check if each part of the input matches in the concatenated full names string
      return searchTerms.every(term =>
        fullName.includes(term)
      );
    });

    if (!this.filteredClients.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1 / 1 / 1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + Utility.parseDateTime(date) : '--';
  }
}
